import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * SPDX-FileCopyrightText: 2025 Genome Research Ltd.
 *
 * SPDX-License-Identifier: MIT
 */
import { useEffect, useState } from "react";
import Modal from "../../general/Modal";
import { generateId } from "../../general/utils";
import { FormTextField } from "../../forms";
import { RSForm, Button } from "../../index";
function NewBoardModal(props) {
    const { setOpen, open, onConfirmClick } = props;
    const [boardId, setBoardId] = useState("");
    const [viewId, setViewId] = useState("");
    const [boardTitle, setBoardTitle] = useState("");
    // @ts-ignore
    const [viewTitle, setViewTitle] = useState("");
    useEffect(() => {
        setBoardId(generateId("b"));
        setViewId(generateId("v"));
    }, []);
    const actionButtons = (_jsxs("div", { children: [_jsx(Button, { position: "right", type: "success", disabled: boardTitle === "" /*|| viewTitle === ""*/, onClick: () => {
                    setOpen(false),
                        onConfirmClick(boardId, viewId, boardTitle, viewTitle);
                }, text: "Create", icon: "plus" }), _jsx(Button, { position: "right", type: "error", onClick: () => setOpen(false), text: "Cancel", icon: "xmark" })] }));
    const header = (_jsx("div", { children: _jsx("h4", { children: "Create New Board" }) }));
    const body = (_jsx(RSForm, { fluid: true, children: _jsx(FormTextField, { id: "board-title", value: boardTitle, onChange: (value) => setBoardTitle(value), name: "Board Title", placeholder: `Id: ${boardId}`, label: "Create a title for your board:" }) }));
    return (_jsx("div", { className: "confirm-delete-buttons", children: _jsx(Modal, { setOpen: setOpen, open: open, size: "xs", children: body, closeButton: false, header: header, actionButton: actionButtons }) }));
}
export default NewBoardModal;
